
import { computed, defineComponent, PropType } from 'vue';
import CMSLinkHandler from '@/shared/content/blocks/helpers/CMSLinkHandler.vue';
import breakpointsState from '@/core/responsive/breakpoints/breakpoints-state.observable';
import MediaHandler from '@/shared/content/blocks/helpers/MediaHandler.vue';
import IndicatorsForNativeHorizontalScroll from '@/shared/content/blocks/native-scroll/IndicatorsForNativeHorizontalScroll.vue';
import { CallToActionTileModel } from '@/types/B2BcontentServerContract';

export default defineComponent({
    name: 'CallToActionSpecialOfferLayout',
    components: { IndicatorsForNativeHorizontalScroll, MediaHandler, CMSLinkHandler },
    props: {
        content: {
            type: Object as PropType<CallToActionTileModel>,
            required: true,
        },
    },
    setup(props) {
        const showCarousel = computed(() => {
            const tileHasMoreThanOneTileContentBlock = props.content.tiles.length > 1;
            const isMobileOrTablet = breakpointsState.activeBreakpoint === 'xs' || breakpointsState.activeBreakpoint === 'sm';
            return tileHasMoreThanOneTileContentBlock && isMobileOrTablet;
        });

        const aspectRatioWithoutCarousel = computed(() => {
            const defaultRatio = { xs: 2 / 1, sm: 10 / 9, default: 4 / 5 };
            if (props.content.tiles.length === 3) {
                return defaultRatio;
            } else if (props.content.tiles.length === 2) {
                return { xs: 2 / 1, default: 10 / 9 };
            } else if (props.content.tiles.length === 1) {
                return { xs: 5 / 6, sm: 1 / 1, default: 2 / 1 };
            }

            return defaultRatio;
        });

        const aspectRatioWithCarousel = computed(() => {
            return { xs: 7 / 11, default: 7 / 8 };
        });

        const textColorClass = computed(() => {
            return `color: ${props.content.textColor}`;
        });

        return {
            aspectRatioWithCarousel,
            aspectRatioWithoutCarousel,
            showCarousel,
            textColorClass,
        };
    },
});
